<template>
  <div class="personal-r">
    <h2>我的订单</h2>
    <div class="option-group clearfix">
      <span class="label">产品名称</span>
      <div class="select">
        <el-select v-model="productId" clearable placeholder="请选择">
          <el-option
            v-for="(item, index) in productList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="block">
        <span class="label">起始日期</span>
        <el-date-picker
          v-model="startTime"
          type="date"
          value-format="yyyy/MM/dd"
          placeholder="请选择日期"
          :picker-options="pickerOptionsStart"
        ></el-date-picker>
      </div>
      <div class="block">
        <span class="label">截止日期</span>
        <el-date-picker
          v-model="endTime"
          align="right"
          type="date"
          value-format="yyyy/MM/dd"
          placeholder="请选择日期"
          :picker-options="pickerOptionsEnd"
        ></el-date-picker>
      </div>
      <em class="btn" @click="getOrderList">查找</em>
    </div>
    <div class="option-group clearfix">
      <span class="label">订单筛选</span>
      <div class="button-box">
        <span v-for="(item, index) in screeningNav" :key="index" :class="{cur: screeningIndex === index}" @click="handleScreening(index)">{{item}}</span>
      </div>
    </div>
    <div class="orderLists">
      <h3 class="column7">
        <span>产品名称</span>
        <span>期限</span>
        <span>应付款（元）</span>
        <span>状态</span>
        <span>交易操作</span>
        <span v-if="this.status !== 0 && this.showSign">续费管理</span>
        <span v-if="this.status === 0 && !this.showSign">订单管理</span>
        <span v-if="this.status !== 0 && !this.showSign">发票</span>
        <span v-if="this.status !== 0 && !this.showSign">订单协议</span>
      </h3>
      <ul>
        <li v-for="(item, index) in orderList" :key="index">
          <p class="th">
            <span>订单编号：{{item.id}}</span>
            <span>下单时间：{{item.orderTime | dateFormat("yyyy-MM-dd")}}</span>
            <span class="red" v-if="item.status == 0 && item.paidMoney != 0">已支付：{{item.paidMoney}}</span>
          </p>
          <div class="td column7">
            <span>
              <router-link :to="'/product/' + item.productId" target="_blank">{{item.productName}}</router-link>
            </span>
            <span v-if="item.dateUnit === 'day'">{{item.monthCount}}天</span>
            <span v-else>{{item.monthCount}}个月</span>
            <span>{{item.payMoney}}</span>

            <!-- 状态栏 -->
            <span v-if="item.status == 0" class="red">未支付</span>
            <span v-else-if="item.status == 1">已支付</span>
            <span v-else-if="item.status == 4">已退款</span>
            <span v-else-if="item.status == 6">已关闭</span>
            <span v-else-if="item.status == 7">已退订</span>
            <span v-else-if="item.status == 8">已取消</span>
            <!-- <span v-else-if="item.status == 9">已暂存</span> -->
            <!-- <span v-else-if="item.status == 10">转暂存</span> -->
            <span v-else-if="item.status == 14">已删除</span>
            <span v-else-if="item.status == 15">已失效</span>
            <span v-else>其他</span>
            <!-- 状态栏 -->

            <!-- 操作栏 -->
            <span v-if="item.status == 0 && item.isExpired == 1">已过期</span>
            <span v-else-if="item.status == 0 && item.isExpired == 0">
              <router-link class="btn" :to="'/order/pay/'+item.id">支付</router-link>
            </span>
            <span v-else>
              <router-link class="btn-check" :to="'/order/detail/'+item.id">查看订单</router-link>
            </span>
            <span v-if="item.status == 0 && item.isExpired == 0 && status === 0">
              <a class="btn" @click="showCancelOrder=true;curOrderID = item.id">取消订单</a>
            </span>
            <!-- 操作栏 -->
            <!-- 电子发票 -->
            <span v-if="item.invoiceStatus == 1 && !showSign">
              <router-link class="btn-check" :to="'/invoice/detail/'+item.id">查看发票</router-link>
            </span>
            <span v-if="item.invoiceStatus != 1 && !showSign">
              <!-- <router-link class="btn-check" :to="'/invoice/detail/'+item.id">查看发票</router-link> -->
            </span>
            <!-- 协议下载 -->
            <span v-if="(item.status == 1 || item.status == 4 || item.status == 6) && !showSign">
              <a href="#" @click="downloadProtocol(item.id)">下载协议</a>
            </span>
            <span v-if="showSign">
              <a class="btn-check" @click="unSign(item.id)" >取消续费</a>
            </span>
          </div>
        </li>
      </ul>
      <!-- 弹框 -->
      <div class="pop" v-show="showCancelOrder">
        <div class="pop-win-confirm">
            <a class="btn-delete" @click="showCancelOrder=false">x</a>
            <h6>确定将这笔未支付订单取消？</h6>
            <p>取消未支付的低端补差升级订单之后才能继续下单！</p>
          <div class="pop-win-btns">
            <a class="btn-cancel" @click="showCancelOrder=false">我再想想</a>
            <a class="btn-confirm" @click="cancelOrder(curOrderID)">取消订单</a>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="current"
      :page-size="size"
      :total="total"
      @current-change="currentChange"
      @size-change="sizeChange"
    ></el-pagination>
  </div>

</template>

<script>
export default {
  data() {
    return {
      current: 1, //当前页
      size: 10, //每页大小
      total: 0,
      orderList: [],
      productList: [],
      productId: "",
      status: '',
      startTime: "",
      endTime: "",
      pickerOptionsStart: {
        disabledDate: time => {
          if (this.endTime) {
            return time.getTime() > new Date(this.endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.startTime) {
            return time.getTime() < new Date(this.startTime).getTime();
          }
        }
      },
      screeningIndex: 0,
      screeningNav: ['全部','已支付','未支付',"续费管理"],
      curOrderID:0,
      showCancelOrder:false,
      payMode: '',
      showSign: false,
    };
  },
  created() {
    this.getProductGroup();
    this.getOrderList();
  },
  methods: {
    unSign(val){
      this.$get("/sign/unSign?id=" + val).then(response => {
        if (response.code === 0) {
          this.$global.alert("解绑成功");
        }else {
          this.$global.alert(response.msg);
        }
      });
    },
    getProductGroup() {
      this.$get("/order/productGroup").then(response => {
        if (response.code === 0) {
          this.productList = response.data;
        }
      });
    },
    getOrderList() {
      var params = {
        productId: this.productId,
        status : this.status,
        startTime: this.startTime,
        endTime: this.endTime,
        current: this.current,
        size: this.size,
        payMode: this.payMode
      };
      this.$get("/order/list", params)
        .then(response => {
          if (response.code === 0) {
            this.total = response.data.total;
            this.orderList = response.data.records;
            if(this.payMode == 37 && this.total > 0){
              this.showSign = true;
            }else{
              this.showSign = false;
            }
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    currentChange(current) {
      this.current = current;
      this.getOrderList();
      window.scrollTo(0, 0)
    },
    sizeChange(size) {
      this.size = size;
      this.getOrderList();
    },
    handleScreening(type) {
      this.screeningIndex = type;
      this.payMode = '';
      switch (type) {
        case 0:
          this.status = '';
          break;
        case 1:
          this.status = 1;
          break;
        case 2:
          this.status = 0;
          break;
        case 3:
          this.status = '';
          this.payMode = 37;
      }
      this.getOrderList();
    },
    downloadProtocol (id) {
      this.$get("/protocol/checkDown?id=" + id).then(
        response => {
          if (response.code === 0 ) {
            let url = window.g.baseUrl + '/protocol/down?id=' + id
            window.location.href = url
          } else {
           this.$global.alert(response.msg);
          }
        }
      );
    },
    cancelOrder(id){
       this.$get("/order/cancel?id=" + id).then(
        response => {
          if (response.code === 0 ) {
            location.reload();
          } else {
           this.$global.alert(response.msg);
          }
        }
      );
    }
    // ,
    // getOperation(status){
    //    return status === 0 ?'订单取消':'交易操作';
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/personal.scss";
.option-group {
  margin: 32px 0 28px;
  span {
    &.label {
      float: left;
      margin: 9px 10px 0 16px;
      @include fc(14px, #222);
    }
  }
  .button-box{
    float: left;
    display: flex;
    span{
      border-radius: 4px;
      background: #F5F5F5;
      border: 1px solid #E5E5E5;
      @include center-text(142px, 32px);
      line-height: 34px;
      font-size: 14px;
      color: #666666;
      margin-right: 20px;
      cursor: pointer;
      &.cur{
        background: #E2EDFF;
        border: 1px solid #66A1FF;
        color: #166FFF;
      }
    }
  }
  .optionList {
    border-color: #979797;
    li {
      border-bottom: 0;
      text-indent: 10px;
    }
  }
  .select {
    &:nth-of-type(1) {
      .optionList {
        width: 195px;
      }
    }
    .selected {
      span {
        @include fc(14px, #222);
      }
    }
  }
}
.select {
  float: left;
  position: relative;
  .selected {
    position: relative;
    width: 195px;
    display: block;
    @include line-height(36px);
    border: 1px solid #e5e5e5;
    cursor: pointer;
    .icon-selectBtn {
      border-left: 0;
      height: 40px;
    }
    span {
      width: 140px;
      border-right: 1px solid #e5e5e5;
      display: block;
      @include text-overflow;
      margin-left: 10px;
      padding-right: 10px;
    }
    .icon-selectBtn {
      top: -2px;
      right: 2px;
    }
    .optionList {
      top: 38px;
    }
  }
}
.orderLists {
  h3 {
    @include wh(100%, 52px);
    line-height: 52px;
    @include fc(18px, #666);
    background: #f5f5f5;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
  }
  .column7 {
    span {
      display: inline-block;
      text-align: center;
      &:first-child {
        width: 150px;
        padding-left: 20px;
        text-align: left;
      }
      &:nth-child(2) {
        width: 90px;
      }
      &:nth-child(3) {
        width: 135px;
      }
      &:nth-child(4) {
        width: 75px;
      }
      &:nth-child(5) {
        width: 150px;
      }
      &:nth-child(6) {
        width: 120px;
      }
    }
  }
  ul {
    li {
      border: 1px solid #c8ddff;
      border-radius: 2px;
      margin-bottom: 14px;
      .th {
        background: #e2edff;
        @include fc(16px, #666);
        line-height: 48px;
        span {
          margin: 28px;
        }
      }
      .td {
        padding: 30px 0;
        font-size: 18px;
        line-height: 38px;
        color: #666666;
        span {
          &.red {
            color: #ef3939;
          }
          &:first-child {
            color: #166fff;
          }
          &:nth-child(3) {
            text-align: center;
            color: #333;
          }
          .btn-check {
            @include fc(18px, #222);
            @include vertical-center(112px, 37px);
            box-sizing: border-box;
            border: 1px solid #666;
            border-radius: 18.5px;
            display: inline-block;
          }
        }
      }
    }
  }
}
.el-date-editor.el-input {
  width: 140px;
  float: left;
}
.pop{
  position:fixed;
  left:0;right:0;bottom:0;top:0;background:rgba(255,255,255,0.5);z-index:10;color:#333;
  &-win-confirm{
    position:fixed;
    left:50%;top:50%;background:#fff;border:2px solid #166EFF;width:400px;height:240px;
    margin:-120px 0 0 -200px;text-align:center;
    h6{
      font-size:24px;padding:65px 20px 10px;
    }
    p{
      font-size:16px;color:#999;
    }
  }
  .btn-delete{
    position:absolute;right:10px;top:10px;width:30px;height:30px;text-align:center;color:#fff;background:#EF3939;line-height:28px;font-size:30px;font-weight:100;
  }
  &-win-btns{
    position:absolute;left:0;bottom:0;right:0;border-top:1px solid #E3E3E3;height:56px;
    a{
      line-height:56px;
      font-size:20px;
      width:50%;float:left;box-sizing:border-box;
      &.btn-confirm{
        color:#286DF7;border-left:1px solid #e3e3e3;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/personal/OrderList.vue